import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=154abe15&"
import script from "./DataTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DataTable.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports